const BaseClass = require('components/BaseClass/BaseClass');
module.exports = BaseClass;
